import React from 'react'
import styles from './styles.css'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import Button from 'orionsoft-parts/lib/components/Button'
import gql from 'graphql-tag'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import PropTypes from 'prop-types'

@withGraphQL(gql`
  query signaturesPacks {
    signaturesPacks {
        _id
        name
        price
    }
  }
`)

@withMessage
export default class AvailablePacks extends React.Component {

  static propTypes = {
    plans: PropTypes.array,
    signaturesPacks: PropTypes.array
  }

  state = {
    loading: false,
    readyToPay: false
  }

  callCrearPagoPack(pack){
    this.props.router.push("/settings/payments/payPack/" + pack._id)
  }

  renderBotonesPagoPack(){
    if(!this.state.readyToPay && this.props.signaturesPacks )
      return this.props.signaturesPacks.map( pack => {
        return (
            <div className={styles.packbtn}>
              <Button className="col-sm-4 col-md-4 col-lg-4" loading={this.state.loading} 
                      primary onClick={() => this.callCrearPagoPack(pack)}>
                  Comprar Pack {pack.name} ( { this.formatCurrency(pack.price)} ) 
              </Button>
            </div>          
        )
      });
  }

  formatCurrency(amount, decimalCount = 0, decimal = ",", thousands = ".") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
      const negativeSign = amount < 0 ? "-" : "";
  
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount), 10).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
  
      return " $"+negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  };

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <h3 className={styles.title}>Paquetes Disponibles</h3>
          </div>
          <div className="content">
            {this.renderBotonesPagoPack()} 
          </div>         
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Settings/Payments/AvailablePacks/index.js